import React from 'react';
import { Placement } from '@noths/polaris-client-ribbons-design-system';

import {
  HOMEPAGE_WITHOUT_PLACEMENT,
  useHomepageRichRelevanceData,
} from 'src/hooks/useHomepageRichRelevanceData/useHomepageRichRelevanceData';
import { RecentlyViewed, RecentlyViewedProps } from './RecentlyViewed';

export interface RecentlyViewedWithRichRelevanceProps extends RecentlyViewedProps {
  placementType: Placement | typeof HOMEPAGE_WITHOUT_PLACEMENT | null;
  sessionId?: string;
  hasDisabledCookies: boolean;
}

export const RecentlyViewedWithRichRelevance = ({
  currency,
  hasDisabledCookies,
  onNavigateCarousel,
  onVisible,
  onProductClick,
  placementType,
  sessionId,
}: RecentlyViewedWithRichRelevanceProps) => {
  const data = useHomepageRichRelevanceData({
    placementType,
    sessionId,
    hasDisabledCookies,
  }) ?? { items: [] };

  return (
    <RecentlyViewed
      currency={currency}
      items={data.items}
      onNavigateCarousel={onNavigateCarousel}
      onVisible={onVisible}
      onProductClick={onProductClick}
      placementTitle={data.message}
      strategy={data.strategy}
    />
  );
};
